import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CategoryCollapse = ({ onChangeCollapse, category }) => (
  <div
    className={classNames('services-import__list-category-collapse', {
      'show-category': !category.collapsed,
      'hide-category': category.collapsed,
    })}
    onClick={onChangeCollapse}
  >
    <span className="services-import__list-category-collapse-name">
      {category.collapsed ? 'Show' : 'Hide'}
      {' '}
      services (
      {category?.services?.length}
      )
    </span>
  </div>
);

CategoryCollapse.propTypes = {
  onChangeCollapse: PropTypes.func,
  category: PropTypes.object,
};

export default CategoryCollapse;
